<form [formGroup]="formGroup">
  <div>
    <h4 class="">{{ 'agents.configsForm.title' | translate }}</h4>
    <small>{{ 'agents.configsForm.subtitle' | translate }}</small>
  </div>

  <div class="mt-3">
    <ul class="nav nav-pills bg-nav-pills nav-justified font-16" role="tablist">
      <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          [ngClass]="{ active: activeConfigTab === ConfigTabType.BEHAVIOR }"
          (click)="changeConfigTab(ConfigTabType.BEHAVIOR)"
          id="behavior-tab"
          data-bs-toggle="tab"
          data-bs-target="#behavior"
          type="button"
          role="tab"
          aria-controls="behavior"
          [attr.aria-selected]="activeConfigTab === ConfigTabType.BEHAVIOR"
          >
          <i class="mdi mdi-chat-outline"></i>
          <span class="d-none d-md-inline ms-2">{{ 'agents.configsForm.tabBehavior' | translate }}</span>
        </a>
      </li>
      <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          [ngClass]="{ active: activeConfigTab === ConfigTabType.TIME }"
          (click)="changeConfigTab(ConfigTabType.TIME)"
          id="time-tab"
          data-bs-toggle="tab"
          data-bs-target="#time"
          type="button"
          role="tab"
          aria-controls="time"
          [attr.aria-selected]="activeConfigTab === ConfigTabType.TIME"
          >
          <i class="mdi mdi-clock-outline"></i>
          <span class="d-none d-md-inline ms-2">{{ 'agents.configsForm.tabTime' | translate }}</span>
        </a>
      </li>
      <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          [ngClass]="{ active: activeConfigTab === ConfigTabType.FOLLOW_UP }"
          (click)="changeConfigTab(ConfigTabType.FOLLOW_UP)"
          id="followup-tab"
          data-bs-toggle="tab"
          data-bs-target="#followup"
          type="button"
          role="tab"
          aria-controls="followup"
          [attr.aria-selected]="activeConfigTab === ConfigTabType.FOLLOW_UP"
          >
          <i class="mdi mdi-bell-outline"></i>
          <span class="d-none d-md-inline ms-2">{{ 'agents.configsForm.tabFollowUp' | translate }}</span>
        </a>
      </li>
    </ul>

    <div class="tab-content p-3 mt-2">
      <!-- Comportamento da Conversa -->
      <div
        class="tab-pane fade show active"
        id="behavior"
        role="tabpanel"
        aria-labelledby="behavior-tab"
        >
        <div class="border rounded p-3">
          <div>
            <h4>{{ 'agents.configsForm.behaviorHeading' | translate }}</h4>
            <small>{{ 'agents.configsForm.behaviorSubtitle' | translate }}</small>
          </div>

          <div class="px-2 mt-3">
            <div class="row">
              <div
                class="d-flex align-items-center justify-content-between mb-3 bg-hover"
                >
                <div class="d-flex flex-column">
                  <span class="font-16 fw-semibold text-dark">{{ 'agents.configsForm.useEmoji' | translate }}</span>
                  <small>{{ 'agents.configsForm.useEmojiHelp' | translate }}</small>
                </div>
                <input
                  type="checkbox"
                  id="enabledEmoji"
                  data-switch="success"
                  formControlName="enabledEmoji"
                  />
                <label for="enabledEmoji"> </label>
              </div>
              <div
                class="d-flex align-items-center justify-content-between mb-3 bg-hover p-2"
                >
                <div class="d-flex flex-column">
                  <span class="font-16 fw-semibold text-dark"
                    >{{ 'agents.configsForm.splitMessages' | translate }}</span
                    >
                    <small>{{ 'agents.configsForm.splitMessagesHelp' | translate }}</small>
                  </div>
                  <input
                    type="checkbox"
                    id="splitMessages"
                    data-switch="success"
                    formControlName="splitMessages"
                    />
                  <label for="splitMessages"> </label>
                </div>
                <div
                  class="d-flex align-items-center justify-content-between mb-3 bg-hover p-2"
                  >
                  <div class="d-flex flex-column">
                    <span class="font-16 fw-semibold text-dark"
                      >{{ 'agents.configsForm.limitSubjects' | translate }}</span
                      >
                      <small>
                        {{ 'agents.configsForm.limitSubjectsHelp' | translate }}
                      </small>
                    </div>
                    <input
                      type="checkbox"
                      id="limitSubjects"
                      data-switch="success"
                      formControlName="limitSubjects"
                      />
                    <label for="limitSubjects"> </label>
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between mb-3 bg-hover p-2"
                    >
                    <div class="d-flex flex-column">
                      <span class="font-16 fw-semibold text-dark"
                        >{{ 'agents.configsForm.smartSearch' | translate }}
                        <span class="badge bg-primary mb-2 ms-1">{{ 'agents.configsForm.betaBadge' | translate }}</span></span
                        >
                        <small>
                          {{ 'agents.configsForm.smartSearchHelp' | translate }}
                        </small>
                      </div>
                      <input
                        type="checkbox"
                        id="knowledgeByFunction"
                        data-switch="success"
                        formControlName="knowledgeByFunction"
                        />
                      <label for="knowledgeByFunction"> </label>
                    </div>

                    <div
                      class="d-flex align-items-center justify-content-between mb-3 bg-hover p-2"
                      >
                      <div class="d-flex flex-column">
                        <span class="font-16 fw-semibold text-dark">{{ 'agents.configsForm.preferredModel' | translate }}</span>
                        <small>
                          {{ 'agents.configsForm.preferredModelHelp' | translate }}
                        </small>
                      </div>
                      <div class="col-2">
                        <mat-select class="form-control" formControlName="prefferModel">
                          @for(model of modelTypes; track $index) {
                            <mat-option [value]="model.value">
                              {{ model.label }}
                              <strong>
                                ({{ model.credits }} {{ 'agents.configsForm.creditsLabel' | translate }})
                              </strong>
                            </mat-option>
                          }
                        </mat-select>
                      </div>
                    </div>

                    <div
                      class="d-flex align-items-center justify-content-between mb-3 bg-hover p-2"
                      >
                      <div class="d-flex flex-column">
                        <span class="font-16 fw-semibold text-dark">{{ 'agents.configsForm.interactionLimit' | translate }}</span>
                        <small>
                          {{ 'agents.configsForm.interactionLimitHelp' | translate }}
                        </small>
                      </div>
                      <div class="col-2">
                        <mat-select class="form-control" formControlName="maxDailyMessages" [placeholder]="'agents.configsForm.selectPlaceholder' | translate">
                          <mat-option [value]="0">{{ 'agents.configsForm.optionNone' | translate }}</mat-option>
                          <mat-option [value]="20">{{ 'agents.configsForm.option20Interactions' | translate }}</mat-option>
                          <mat-option [value]="50">{{ 'agents.configsForm.option50Interactions' | translate }}</mat-option>
                          <mat-option [value]="100">{{ 'agents.configsForm.option100Interactions' | translate }}</mat-option>
                          <mat-option [value]="200">{{ 'agents.configsForm.option200Interactions' | translate }}</mat-option>
                          <mat-option [value]="500">{{ 'agents.configsForm.option500Interactions' | translate }}</mat-option>
                          <mat-option [value]="1000">{{ 'agents.configsForm.option1000Interactions' | translate }}</mat-option>
                        </mat-select>
                      </div>
                    </div>
                    @if($safeNavigationMigration(formGroup.get('maxDailyMessages')?.value) !== null && formGroup.get('maxDailyMessages')?.value !== 0) {
                      <div
                        class="d-flex align-items-center justify-content-between mb-3 bg-hover p-2"
                        >
                        <div class="d-flex flex-column">
                          <span class="font-16 fw-semibold text-dark">{{ 'agents.configsForm.limitAction' | translate }}</span>
                          <small>
                            {{ 'agents.configsForm.limitActionHelp' | translate }}
                          </small>
                        </div>
                        <div class="col-2">
                          <mat-select class="form-control" formControlName="maxDailyMessagesLimitAction" [placeholder]="'agents.configsForm.selectPlaceholder' | translate">
                            <mat-option value="TEMP_BLOCK_30S">{{ 'agents.configsForm.blockFor30s' | translate }}</mat-option>
                            <mat-option value="TEMP_BLOCK_5M">{{ 'agents.configsForm.blockFor5m' | translate }}</mat-option>
                            <mat-option value="TEMP_BLOCK_10M">{{ 'agents.configsForm.blockFor10m' | translate }}</mat-option>
                            <mat-option value="TEMP_BLOCK_30M">{{ 'agents.configsForm.blockFor30m' | translate }}</mat-option>
                            <mat-option value="TEMP_BLOCK_1H">{{ 'agents.configsForm.blockFor1h' | translate }}</mat-option>
                            <mat-option value="BLOCK">{{ 'agents.configsForm.blockPermanently' | translate }}</mat-option>
                            <mat-option value="TRANSFER">{{ 'agents.configsForm.transferToHuman' | translate }}</mat-option>
                          </mat-select>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>

            <!-- Configurações de Tempo -->
            <div
              class="tab-pane fade"
              id="time"
              role="tabpanel"
              aria-labelledby="time-tab"
              >
              <div class="border rounded p-3">
                <div>
                  <h4>{{ 'agents.configsForm.timeHeading' | translate }}</h4>
                  <small>{{ 'agents.configsForm.timeSubtitle' | translate }}</small>
                </div>

                <div
                  class="d-flex align-items-center justify-content-between mt-3 mb-3 bg-hover p-2"
                  >
                  <div class="d-flex flex-column">
                    <span class="font-16 fw-semibold text-dark">
                      {{ 'agents.configsForm.responseTime' | translate }}
                    </span>
                    <small>
                      {{ 'agents.configsForm.responseTimeHelp' | translate }}
                    </small>
                  </div>
                  <div class="col-2">
                    <mat-select class="form-control" formControlName="messageGroupingTime">
                      <mat-option value="NO_GROUP">{{ 'agents.configsForm.immediately' | translate }}</mat-option>
                      <mat-option value="FIVE_SEC">{{ 'agents.configsForm.fiveSeconds' | translate }}</mat-option>
                      <mat-option value="TEN_SEC">{{ 'agents.configsForm.tenSeconds' | translate }}</mat-option>
                      <mat-option value="THIRD_SEC">{{ 'agents.configsForm.threeSeconds' | translate }}</mat-option>
                      <mat-option value="ONE_MINUTE">{{ 'agents.configsForm.oneMinute' | translate }}</mat-option>
                    </mat-select>
                  </div>
                </div>
              </div>
            </div>

            <!-- Configurações de Follow-up -->
            <div
              class="tab-pane fade"
              id="followup"
              role="tabpanel"
              aria-labelledby="followup-tab"
              >
              <div class="border rounded p-3">
                <div>
                  <h4>{{ 'agents.configsForm.followUpHeading' | translate }}</h4>
                  <small>{{ 'agents.configsForm.followUpSubtitle' | translate }}</small>
                </div>

                <div class="px-2 mt-3">
                  <div class="row">
                    <div class="col-12 mb-3">
                      <label class="form-label">{{ 'agents.configsForm.endAttendanceAfter' | translate }}</label>
                      <select class="form-select" formControlName="finishOnTime">
                        @for (timeOption of timeOptions; track timeOption) {
                          <option [ngValue]="timeOption.value">
                            {{ timeOption.label | translate }}
                          </option>
                        }
                      </select>
                      <small class="text-muted">{{ 'agents.configsForm.endAttendanceHelp' | translate }}</small>
                    </div>

                    <div class="col-12">
                      <label class="form-label">{{ 'agents.configsForm.followUpActions' | translate }}</label>
                      <div formArrayName="followUpActions" class="mb-3">
                        @for (actionGroup of followUpActions.controls; let i = $index; track i) {
                          <div class="border rounded p-3 mb-3" [formGroupName]="i">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                              <h5 class="mb-0">{{ 'agents.configsForm.followUpItem' | translate }} #{{i+1}}</h5>
                              <div>
                                <button type="button" class="btn btn-icon btn-sm btn-outline-secondary me-1" (click)="openWorkingHoursModal(i)">
                                  <i class="ri-settings-3-line"></i>
                                </button>
                                <button type="button" class="btn btn-icon btn-sm btn-outline-danger" (click)="removeFollowUpAction(i)">
                                  <i class="ri-delete-bin-line"></i>
                                </button>
                              </div>
                            </div>

                            <div class="mb-3">
                              <label class="form-label">{{ 'agents.configsForm.ifNoResponseIn' | translate }}</label>
                              <select class="form-select" formControlName="seconds">
                                @for (timeOption of timeOptions; track timeOption) {
                                  <option [ngValue]="timeOption.value">{{ timeOption.label | translate }}</option>
                                }
                              </select>
                            </div>

                            <div class="mb-3">
                              <label class="form-label">{{ 'agents.configsForm.agentShould' | translate }}</label>
                              <textarea class="form-control" formControlName="instructions" rows="3" [placeholder]="'agents.configsForm.followUpPlaceholder' | translate"></textarea>
                            </div>

                          </div>
                        }
                      </div>

                      @if (followUpActions.length === 0) {
                        <div class="text-center text-muted py-4">
                          <i class="mdi mdi-bell-off fs-1"></i>
                          <p class="mt-2">{{ 'agents.configsForm.noFollowUpActions' | translate }}</p>
                        </div>
                      }

                      <button type="button" class="btn btn-outline-primary mt-1" (click)="addFollowUpAction()">
                        <i class="ri-add-line"></i> {{ 'agents.configsForm.addAction' | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
